import { withUserContext, withUIContext } from 'context'
import { FormContainer, Image, Icon, Text, ButtonSimple, CustomLink } from 'components/common'
import LoginPopupStyle from './style'

const SignUp = ({ socialLogin, closePopup }) => {
    return (
        <LoginPopupStyle className={`parent-cont flexBoxColumn alignMiddle`}>
            <FormContainer className='login flexBoxColumn'>
                <Icon className='op-close cursorPointer' onClick={closePopup} />
                <Text tag={'h4'} className={'h4 PopSemi title'} text={'Sign Up'} />
                <button className='social-btn-login cursorPointer google' type='button' onClick={() => socialLogin('google')}>
                    <Image className='soc-icon' src='/images/SocialIcons/google.svg' />
                    <Text tag={'p'} className={'PopSemi'} text={'Sign Up With Google'} />
                </button>
                <button className='social-btn-login cursorPointer facebook' type='button' onClick={() => socialLogin('facebook')}>
                    <Image className='soc-icon' src='/images/SocialIcons/facebook.svg' />
                    <Text tag={'p'} className={'PopSemi white'} text={'Sign Up With Facebook'} />
                </button>
                <button className='social-btn-login cursorPointer linkedin' type='button' onClick={() => socialLogin('linkedin')}>
                    <Image className='soc-icon' src='/images/SocialIcons/linkedin.svg' />
                    <Text tag={'p'} className={'PopSemi white'} text={'Sign Up With Linkedin'} />
                </button>
                <div className='or'>
                    <Text tag={'p'} className='PopSemi' text={'or'} />
                </div>
                <CustomLink className='sign' url='/register'>
                    <ButtonSimple className='sign-up-btn ' text='Sign up via email' />
                </CustomLink>
                <CustomLink className='have-account' url={'/?c=login'}>
                    <Text tag={'p'} className='PopReg purple forgot' text='Already have an account?' />
                </CustomLink>
            </FormContainer>
        </LoginPopupStyle>
    )
}

export default withUIContext(withUserContext(SignUp, ['socialLogin']), ['closePopup'])
